import WFacebookLike from '../../WFacebookLike';
import { WithConsentPolicy } from '../../../../ConsentPolicyWrapper/viewer/ConsentPolicyWrapper';
import styles from '../../styles/WFacebookLike.scss';

export default WithConsentPolicy(WFacebookLike, {
  rootClassName: styles.root,
  componentConsentPolicy: { advertising: true },
});
